import { connect } from 'react-redux'
import Feedback from '..'
import { ApplyRole, RejectedRole } from '../../../actions'
import {
  geStudentQuestionaireResult,
  updateStudentFeedback,
} from '../../actions'

const mapStateToProps = state => ({})
const mapDispatchToProps = {
  updateStudentFeedback,
  ApplyRole,
  RejectedRole,
  geStudentQuestionaireResult,
}
export default connect(mapStateToProps, mapDispatchToProps)(Feedback)
